export const agentQuery = ({ auth, profile }) => {
  if (profile.role === 'manager') {
    return [
      {
        collection: 'agents',
        //where: [ 'complainant.uid', '==', auth.uid ],
        orderBy: 'displayName',
        limit: 10,
        storeAs: 'agents',
      },
    ];
  } else {
    return [];
  }
};
